module.exports = __webpack_public_path__ + "img/liangtang-back-two@2x.bce4c473.png";